import { createUseStyles } from 'react-jss';

import { ITheme, FontWeight, mediaQuery } from '../../../styles';

const useStyles = createUseStyles<string, { showDescription: boolean }, ITheme>(
  ({ colors, breakpoints }: ITheme) => ({
    root: {
      display: 'flex',
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: ({ showDescription }) => (showDescription ? 'start' : 'center'),
      width: '100%',
      top: 24,
      minHeight: 32,
      gap: 8,
    },
    newLabel: {
      color: colors.white,
      backgroundColor: 'var(--x-new-label-color)',
      borderRadius: '72px',
      marginLeft: 'auto',
      marginRight: ({ showDescription }) => (showDescription ? 0 : 12),
      padding: [4, 12],
      maxHeight: 24,

      fontSize: 12,
      textAlign: 'center',
      fontWeight: FontWeight.SemiBold,
    },
    itemTitle: {
      color: colors.textField,
      fontWeight: FontWeight.SemiBold,

      fontSize: ({ showDescription }) => (showDescription ? 24 : 16),
      lineHeight: ({ showDescription }) => (showDescription ? '32px' : '28px'),
      display: 'flex',
      gap: '16px',
      alignItems: 'center',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: () => 20,
        lineHeight: () => '28px',
      },
    },
    itemTitleText: {
      wordBreak: 'break-word',
    },
    itemDescription: {
      color: 'var(--x-text-color-2)',
      fontSize: '16px',
      lineHeight: '24px',
      margin: '12px 0 24px 0',
    },
    cta: {
      background: 'var(--x-bg-6)',
      borderRadius: '72px',
      display: 'inline-block',
      padding: 4,
      width: 24,
      height: 24,
    },
    arrow: {
      width: 16,
      height: 16,
      fill: 'var(--x-textf-field-color-1)',
    },
    listItem: {
      flex: 1,
      display: 'flex',
      position: 'relative',
      boxShadow: 'none',
      borderRadius: '16px',
      padding: ({ showDescription }) => (showDescription ? [24, 24, 16, 24] : [22, 24]),
      flexDirection: ({ showDescription }) => (showDescription ? 'column' : 'row'),
      alignItems: ({ showDescription }) => (showDescription ? 'flex-start' : 'center'),

      '&:hover': {
        cursor: 'pointer',
        boxShadow: '0px 4px 16px var(--x-shadow-card)',
      },
    },
    spacer: {
      flex: 1,
    },
  }),
  {
    name: 'SingleToolCard',
  },
);

export default useStyles;
